/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useEffect, useState } from "react";

import ProductShapeList from "../Elements/ProductShapeList";

const GasStationServices = ({ acceptanceItems, servicesItems }) => {
    const acceptanceName = "Akzeptanzpartner";
    const servicesName = "Services";
    const showMore = "Alle anzeigen";
    const showLess = "Weniger anzeigen";
    const [acceptanceList, setAcceptanceList] = useState([]);
    const [servicesList, setServicesList] = useState([]);
    const [isAcceptanceItemsLoaded, setIsAcceptanceItemsLoaded] =
        useState(false);
    const [isServicesItemsLoaded, setIsServicesItemsLoaded] = useState(false);

    useEffect(() => {
        setServicesList(
            isServicesItemsLoaded ? servicesItems : servicesItems.slice(0, 6)
        );
        setAcceptanceList(
            isAcceptanceItemsLoaded
                ? acceptanceItems
                : acceptanceItems.slice(0, 6)
        );
    }, [
        acceptanceItems,
        servicesItems,
        isServicesItemsLoaded,
        isAcceptanceItemsLoaded,
    ]);

    const getItems = () => {
        const _items = [];
        if (servicesList.length > 0) {
            const _item = {
                name: servicesName,
                items: servicesList,
            };
            if (servicesItems.length > 6) {
                _item.onLoadMore = () => {
                    setIsServicesItemsLoaded(!isServicesItemsLoaded);
                };
                _item.buttonText = isServicesItemsLoaded ? showLess : showMore;
            }
            _items.push(_item);
        }
        if (acceptanceList.length > 0) {
            const _item = {
                name: acceptanceName,
                items: acceptanceList,
            };
            if (acceptanceItems.length > 6) {
                _item.onLoadMore = () => {
                    setIsAcceptanceItemsLoaded(!isAcceptanceItemsLoaded);
                };
                _item.buttonText = isAcceptanceItemsLoaded
                    ? showLess
                    : showMore;
            }
            _items.push(_item);
        }
        return _items;
    };

    return (
        (acceptanceList.length > 0 || servicesList.length > 0) && (
            <ProductShapeList items={getItems()} />
        )
    );
};

export default GasStationServices;
